// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"684ef59c","296":"684ef59c","587":"0c07ee4b","812":"d5eaf869","896":"d4ca0210"}[chunkId] + ".chunk.css";
};